import React from 'react';
import './Founder.css';
import founderImage from '../founder.jpeg';
import semiIcon from '../semi.png';
import nameImage from '../name.png';

const Founder = () => {
  return (
    <section className="founder-section">
      <div className="container">
        <div className="founder-header">
          <div className="founder-line"></div>
          <h2 className="founder-title">Founder's Message</h2>
        </div>
        
        <div className="founder-content">
          <div className="founder-text">
            <div className="quote-icon">
              <img src={semiIcon} alt="Quote" />
            </div>
            
            <div className="founder-message">
              <p>
                Kanishana Acharya Raghuman was born on 27 November 1940. He dedicated his entire life to the preservation and 
                propagation of Vedic knowledge, leading a life rooted in discipline, simplicity, and 
                spiritual devotion. A true practitioner of the Guru-Shishya tradition, he devoted 
                himself to teaching the Vedas, sacred rituals, and Samskaras, guiding generations of 
                students with unwavering commitment and humility. His life was a living example of 
                Dharma in practice, where learning was inseparable from spiritual discipline and 
                service to society. Through his teachings and values, he laid a strong foundation for 
                Sri Veda Gurukulam, ensuring that timeless Vedic wisdom continues to be passed on 
                to future generations.
              </p>
            </div>
            
            <div className="philosophy">
              <h3>Philosophy</h3>
              <ul>
                <li>• Discipline as the foundation of learning</li>
                <li>• Spiritual practice as daily life</li>
                <li>• Service to society through Dharma</li>
              </ul>
            </div>
            
            <div className="founder-signature">
              <img src={nameImage} alt="Kanishana Acharya Raghuman" />
            </div>
          </div>
          
          <div className="founder-image">
            <img src={founderImage} alt="Founder" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;